import angular from 'angular';
import '../shared.module';

function cpFileSrcDirective(UploadService) {
  return {
    restrict: 'A',
    link(scope, element, attrs) {
      attrs.$observe('cpFileSrc', (fileId) => {
        element.removeAttr('src');
        if (!fileId) return;
        UploadService.cachedFileUrl(fileId).then(
          (url) => {
            if (attrs.cpFileSrc === fileId) element.attr('src', url);
          },
          () => null
        );
      });
    }
  };
}

cpFileSrcDirective.$inject = ['UploadService'];

angular.module('app.shared').directive('cpFileSrc', cpFileSrcDirective);
